// UI scope of the separate care-management workspace.
export const REMOVED_APP_VIEWS = new Set([
  "mockup",
  "regulatory_compliance",
  "stock_financials",
  "shelfPictorialView",
  "stock_excess",
  "stock_graphs",
  "stock_invoices",
  "warehouse_view",
  "services",
  "nms",
  "appts_analysis",
  "dashpanels",
  "business_insights"
]);
export const CARE_HEAD_OFFICE_KEYS = new Set(["fridge","cleaning","visitorLogs","sop","appraisals","staff","training","accidentBook","mhra","patientFeedback"]);
export const isCareViewAllowed = view => !REMOVED_APP_VIEWS.has(view);
export const isCareDashboardAllowed = key => CARE_HEAD_OFFICE_KEYS.has(key);
export function isCareNavigationAllowed(navigate) {
 if (!navigate) return true;
 if (navigate.type === "view") return isCareViewAllowed(navigate.view);
 if (navigate.type === "headoffice") return isCareDashboardAllowed(navigate.key);
 return true;
}
